import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Alert, Button } from 'antd'

/**
 * Cô lập lỗi của module scanner (camera/WebRTC dễ lỗi: chunk load fail khi mạng kém,
 * browser cũ không hỗ trợ, runtime error trong html5-qrcode) để không sập cả app.
 * Lưu ý: error boundary chỉ bắt được lỗi render/lifecycle + lỗi tải chunk lazy,
 * KHÔNG bắt được lỗi async như từ chối quyền camera (xử lý riêng trong BarcodeScanner).
 */
class ScannerErrorBoundary extends Component {
    state = { hasError: false, detail: '' }

    static getDerivedStateFromError(error) {
        // html5-qrcode hay throw chuỗi thuần (không phải Error), nên không dựa vào error.message.
        const detail = (error && (error.message || error.toString())) || String(error)
        return { hasError: true, detail }
    }

    componentDidCatch(error, errorInfo) {
        console.error('[BarcodeScanner] error:', error, errorInfo)
    }

    render() {
        if (this.state.hasError) {
            return (
                <Alert
                    type="error"
                    showIcon
                    className="mt-3"
                    message="Không tải được trình quét camera"
                    description={
                        <>
                            <div>Vui lòng kiểm tra kết nối mạng hoặc nhập mã đơn bằng tay.</div>
                            {this.state.detail && (
                                <div style={{ marginTop: 8, fontSize: 12, opacity: 0.75, wordBreak: 'break-word' }}>
                                    Chi tiết: {this.state.detail}
                                </div>
                            )}
                            {this.props.onClose && (
                                <div style={{ marginTop: 8 }}>
                                    <Button size="small" onClick={this.props.onClose}>Đóng</Button>
                                </div>
                            )}
                        </>
                    }
                />
            )
        }
        return this.props.children
    }
}

ScannerErrorBoundary.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func,
}

export default ScannerErrorBoundary
